import React from "react";
import { useRefinementList } from "react-instantsearch";
import Accordion from "../../../UI/Accordion/Accordion";
import "./CustomCheckbox.scss";

const Checkbox = (props) => {
    const { panelTitle, attribute, operator, limit, showMore, showMoreLimit } =
        props;
    const { items, refine, canRefine, isShowingMore, toggleShowMore } =
        useRefinementList(props);

    const refinementHandler = (evt, item) => {
        refine(item.value);
    };

    let refinementContent = (
        <Accordion header={panelTitle}>
            <div
                className="search-filter__checkboxes"
                attribute={attribute}
                operator={operator}
                limit={limit}
                showmore={showMore}
                showmorelimit={showMoreLimit}
            >
                <ul className="search-filter__option-list">
                    {items.map((item, index) => {
                        return (
                            <li
                                key={item.value}
                                data-insights-filter={`${attribute}:${item.value}`}
                            >
                                <label className="search-filter__checkbox">
                                    <input
                                        type="checkbox"
                                        name="checkbox"
                                        checked={item.isRefined}
                                        onChange={(evt) =>
                                            refinementHandler(evt, item)
                                        }
                                    />
                                    {item.label}
                                    <span className="search-filter__option-count">
                                        ({item.count})
                                    </span>
                                </label>
                            </li>
                        );
                    })}
                </ul>
                {showMore && items.length >= limit && (
                    <button
                        onClick={toggleShowMore}
                        className="search-filter__show-more-button"
                    >
                        {isShowingMore
                            ? "weniger anzeigen - "
                            : "mehr anzeigen +"}
                    </button>
                )}
            </div>
        </Accordion>
    );

    return <>{canRefine ? refinementContent : null}</>;
};

export default Checkbox;
